import BoardColumn from './BoardColumn';

export default BoardColumn;
